'use client';

import type { PrototypeEntry } from './prototype-entry';

/**
 * Registered prototype demos.
 *
 * Main ships with none, so the status-bar menu stays hidden. A prototype
 * branch adds its `use…PrototypeEntry` hook to this function and includes the
 * result in the returned list. Call every entry hook unconditionally — each
 * entry still hides itself with `enabled` when its own flag is off.
 *
 * `caseId` is the open case, when there is one. Entry hooks that mount demo
 * data for a case should take it.
 */
export function usePrototypeEntries(
  _caseId: string | undefined,
): PrototypeEntry[] {
  return [];
}
